
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbCard',
  setup() {
    const baseClass = 'epb-card'
    return {
      baseClass,
    }
  },
})
